export const EXT_NAME = 'teambit.workspace/workspace';
